import { logAmplitudeEvent } from 'amplitude/amplitude'
//OPTIONS: 'GA4', 'AMPLITUDE'
const trackingPlatforms = ['AMPLITUDE']

export type BannerAdAnalyticsParams = {
  campaign_name: string
  creative_name: string
  format: string
  placement: string
}

/** Amplitude/GA4 impression logging — shared by struct banners (BannerAd) and ads2 (AdServer). */
export const logBannerAdImpression = (eventParameters: BannerAdAnalyticsParams) => {
  if (trackingPlatforms.includes('GA4')) {
    window.GA4?.recordEvent('ad_impression', eventParameters)
  }
  if (trackingPlatforms.includes('AMPLITUDE')) {
    logAmplitudeEvent('ad_impression', eventParameters)
  }
}

/** Amplitude/GA4 click logging — shared by struct banners (BannerAd) and ads2 (AdServer). */
export const logBannerAdClick = (eventParameters: BannerAdAnalyticsParams) => {
  if (trackingPlatforms.includes('GA4')) {
    window.GA4?.recordEvent('ad_click', eventParameters)
  }
  if (trackingPlatforms.includes('AMPLITUDE')) {
    logAmplitudeEvent('ad_click', eventParameters)
  }
}
